__turbopack_context__.v({
  "arcCircle": "AUC2mW_arcCircle",
  "arcSvg": "AUC2mW_arcSvg",
  "bgWrapper": "AUC2mW_bgWrapper",
  "chargingLabel": "AUC2mW_chargingLabel",
  "counter": "AUC2mW_counter",
  "daysLabel": "AUC2mW_daysLabel",
  "desktopBgImage": "AUC2mW_desktopBgImage",
  "dialContainer": "AUC2mW_dialContainer",
  "drawArc": "AUC2mW_drawArc",
  "glassCircle": "AUC2mW_glassCircle",
  "labelStack": "AUC2mW_labelStack",
  "midArc": "AUC2mW_midArc",
  "mobileBgImage": "AUC2mW_mobileBgImage",
  "scrollWrapper": "AUC2mW_scrollWrapper",
  "section": "AUC2mW_section",
  "stickyContainer": "AUC2mW_stickyContainer",
  "textContent": "AUC2mW_textContent",
  "uptoLabel": "AUC2mW_uptoLabel" + " " + __turbopack_context__.i(515534)["sectionLabel"],
});
